import React, { Component } from "react";

import ItemPreview from "./ItemPreview";

export default class ProductList extends Component {
	constructor(props) {
		super(props);

		// Add product impression
		if (!!this.props.addImpression && props.products.length) {
			props.products.forEach(prod => {
				this.props.addImpression(prod);
			});
		}
	}

	render() {
		return (
			<div className="react_product_wrap">
				{!!this.props.products && this.props.products.length ? (
					this.props.products.map((product, i) => {
						return <ItemPreview key={i} product={product} />;
					})
				) : (
					<div>No results</div>
				)}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/ProductList.js